import React from 'react';
import { PartnerWithUsCompanyForm } from 'components/layout/forms';
import { PageWrapper2 } from 'components/modules/Wrapper2';
// import { home } from 'assets/images';
function PartnerWithUsCompanyView() {
	return (
		<div className='bg-[#0E1022]'>
			<PageWrapper2>
				<div>
					<PartnerWithUsCompanyForm />
				</div>
			</PageWrapper2>
		</div>
	);
}

export default PartnerWithUsCompanyView;
